import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import people from '../../assets/icons/group-icon.svg';

const IconGroupPpl = (props) => {
    const { className, rootClassName } = props;
    const classes = classNames(rootClassName, className);

    return <img className={classes} src={people} alt="people icon" />;
};

const { string } = PropTypes;

IconGroupPpl.defaultProps = {
    className: null,
    rootClassName: null,
};

IconGroupPpl.propTypes = {
    className: string,
    rootClassName: string,
};

export default IconGroupPpl;
